import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  NodeClickEventArgs,
  NodeSelectEventArgs,
  TreeViewComponent,
} from "@syncfusion/ej2-vue-navigations";
import {useAccountStore} from "@/stores/accountStore";
import PersonIds from "@/shared/model/PersonIds";
import {Action} from "@/shared/model/Action";
import {ref, watch} from "vue";
import {storeToRefs} from "pinia";
import getGuid from "@/shared/utils/getGuid";
import apiAuth from "@/shared/services/apiAuth";
import router from "@/app/routes";

interface Props {
  id?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface MenuItem {
  id: string;
  path: string | undefined;
  text: string;
  items: MenuItem[] | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MenuSideBarComponent',
  props: {
    id: { default: undefined }
  },
  emits: ["navigate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const _emits = __emit;

const _accountStore = useAccountStore();
const {authenticated} = storeToRefs(_accountStore);

const defaultMenuItem: MenuItem = {
  id: getGuid(),
  items: undefined,
  text: "",
  path: undefined,
};

const menuItems = ref([
  {...defaultMenuItem, id: getGuid(), text: "Home", path: "/"},
]);
const fields = {
  dataSource: menuItems,
  id: "id",
  text: "text",
  child: "items",
};

watch(
  authenticated,
  (newValue) => {
    show(newValue);
  },
  {immediate: true}
);

function show(auth: boolean) {
  const accountStore = useAccountStore();

  if (accountStore.installation.shopId === "eVB_Aktivierung") {
    return;
  }
  if (!auth) {
    menuItems.value = [
      {...defaultMenuItem, id: "login", text: "Anmelden", path: ""},
    ];
    return;
  }

  const menu = [];

  const excludeWithoutRight = accountStore.person && (accountStore.person.isLossAdjuster() || accountStore.person?.id === PersonIds.UsNato);

  menu.push({...defaultMenuItem, id: getGuid(), text: "Home", path: "/"});

  if (accountStore.person && accountStore.person.isLossAdjuster()) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Recherche",
      path: "/lossadjuster/search",
    });
    if (accountStore.hasAction(Action.BordereauManage)) {
      menu.push({
        ...defaultMenuItem,
        id: getGuid(),
        text: "Bordereau",
        path: "/lossadjuster/bordereau",
      });
    }
  }

  //["all","ConfigShopManage","AccountManage","ProductPriceManage","Sale","Purchase","admin","WebSiteManage","OrganisationStructureManage"]

  const accounting: MenuItem[] = [];
  const options: MenuItem[] = [];

  if (accountStore.user && accountStore.hasAction(Action.Purchase)) {
    if (!accountStore.isBranch) {
      accounting.push({
        ...defaultMenuItem,
        id: getGuid(),
        text: "Eingangsrechnungen",
        path: "/order/purchase/list/Invoice",
      });
    }
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Einkauf",
      path: "",
      items: [
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Einzeleinkauf",
          path: "/shoppingcartsingleproduct/purchase/producttype",
        },
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Einkaufen",
          path: "/shoppingcart/purchase/add",
        },
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Bestellungen",
          path: "/order/purchase/list/Order",
        },
      ],
    });
  }
  if (accountStore.user && accountStore.hasAction(Action.Sale) && !accountStore.isBranch) {
    accounting.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Ausgangsrechnungen",
      path: "/order/sale/list/Invoice",
    });
    const menuSale: MenuItem[] = [];
    if (accountStore.isRoot || true) {
      menuSale.push({
        ...defaultMenuItem,
        id: getGuid(),
        text: "Verkaufen",
        path: "/shoppingcart/sale/add",
      });
    }
    menuSale.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Bestellungen",
      path: "/order/sale/list/Order",
    });

    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Verkauf",
      path: "",
      items: menuSale,
    });
  }

  console.log(accounting)

  if (accounting.length > 0) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Buchhaltung",
      path: "",
      items: accounting,
    });
  }

  if (accountStore.person && !excludeWithoutRight) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Versicherungen",
      path: "/insurance/list",
    });
  }
  /*
  if (accountStore.user) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Stornierungen",
      path: "/insurancecancelation/list",
    });
  }
  if (accountStore.isRoot) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Verwaltung",
      path: "/insurancecancelation/management",
    });
  }
 */
  if (accountStore.isRoot) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Stornierungen",
      path: "",
      items: [
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Übersicht",
          path: "/insurancecancelation/list",
        },
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Verwaltung",
          path: "/insurancecancelation/management",
        },
      ],
    });
  } else if (!excludeWithoutRight && !accountStore.isBranch) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Stornierungen",
      path: "",
      items: [
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Übersicht",
          path: "/insurancecancelation/list",
        },
      ],
    });
  }


  if (accountStore.user && accountStore.isRoot) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Kfz-Zulassungen",
      path: "/vehicleregistration/list",
    });
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Recherche-Mails",
      path: "/registrationinquiry/list",
    });
  }

  if (accountStore.user && !excludeWithoutRight) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Ausfuhrformulare",
      path: "/insuranceexportblank/list",
    });
  }

  if (accountStore.user && accountStore.hasAction(Action.OrganisationStructureManage)) {
    if (accountStore.person?.id === PersonIds.UsNato || accountStore.person?.isLossAdjuster()) {
      menu.push({
        ...defaultMenuItem,
        id: getGuid(),
        text: "Organisationsstruktur",
        path: "",
        items: [
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Alle",
            path: "/organisationstructure/list/all",
          },
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Mitarbeiter",
            path: "/organisationstructure/list/employee",
          },
        ],
      });
    } else {
      menu.push({
        ...defaultMenuItem,
        id: getGuid(),
        text: "Organisationsstruktur",
        path: "",
        items: [
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Alle",
            path: "/organisationstructure/list/all",
          },
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Kunden",
            path: "/organisationstructure/list/customer",
          },
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Filialen",
            path: "/organisationstructure/list/branch",
          },
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Mitarbeiter",
            path: "/organisationstructure/list/employee",
          },
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Lieferanten",
            path: "/organisationstructure/list/supplier",
          },
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Versicherer",
            path: "/organisationstructure/list/manufacturer",
          },
          ...(accountStore.isRoot ? [{
            ...defaultMenuItem,
            id: getGuid(),
            text: "Zulassungsstellen",
            path: "/organisationstructure/list/registrationoffice",
          }] : []),
          {
            ...defaultMenuItem,
            id: getGuid(),
            text: "Vorlagefiliale",
            path: "/organisationstructure/list/branch_template",
          },
        ],
      });
    }
  }

  const t_items = [
    {
      ...defaultMenuItem,
      id: getGuid(),
      text: "Bestand",
      path: "/store/list",
    },
    {
      ...defaultMenuItem,
      id: getGuid(),
      text: "Lieferungen",
      path: "/store/delivery",
    },
  ];

  if (accountStore.user && accountStore.isRoot) {
    t_items.push(    {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Ausfuhrformulare",
          path: "/store/exportblank",
        },
    );
  }

  if (accountStore.person && !excludeWithoutRight) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Lager",
      path: "",
      items: t_items,
    });
  }

  if (accountStore.user && accountStore.isRoot && accountStore.hasAction(Action.BordereauManage)) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Bordereau",
      path: "",
      items: [
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Wakam",
          path: "/bordereau/wakam",
        },
        {
          ...defaultMenuItem,
          id: getGuid(),
          text: "Van Ameyde",
          path: "/lossadjuster/bordereau",
        },
        {...defaultMenuItem, id: getGuid(), text: "US Nato", path: "/usnato"},
      ],
    });
  }

  if (accountStore.user && (accountStore.person?.isSupplier() || accountStore.person?.isCustomer())) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Berichte",
      path: "/report",
    });
  }

  if (accountStore.user && accountStore.hasAction(Action.ConfigShopManage)) {
    options.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Rechnung",
      path: "",
    });
  }
  if (accountStore.user && accountStore.hasAction(Action.WebSiteManage)) {
    options.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Impressum",
      path: "",
    });
  }
  if (accountStore.user && accountStore.hasAction(Action.GdvAccessManage)) {
    options.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "GDV-Zugänge",
      path: "/gdvaccess",
    });
  }

  if (options.length > 0) {
    menu.push({
      ...defaultMenuItem,
      id: getGuid(),
      text: "Einstellungen",
      path: "",
      items: options,
    });
  }

  menuItems.value = menu;
}

function onLog(args: any) {
  console.log(args);
}

function onSelected(args: NodeSelectEventArgs) {
  return;
  /*
    console.log(args)

    if (args.isInteracted) {
      const menuItem = getMenu(args.nodeData["id"] as string, args.nodeData["parentID"] as string)
      if (menuItem) {
        if (menuItem.id === "login") {
          apiAuth.login(undefined);
          return
        }
        if (menuItem.id === "logout") {
          apiAuth.logout();
          return
        }

        if (menuItem.path) {
          _emits("navigate")
          if (menuItem.path.startsWith("http"))
            window.open(menuItem.path, "_blank");
          else
            router.push(menuItem.path);
        }
      }
    }
  */
}

function onClicked(args: NodeClickEventArgs) {
  //console.log(args.node.dataset.uid)
  const menuItem = getMenu(args.node.dataset.uid as string, menuItems.value);
  //console.log(menuItem)
  if (menuItem) {
    if (menuItem.id === "login") {
      apiAuth.login(undefined);
      return;
    }
    if (menuItem.id === "logout") {
      apiAuth.logout();
      return;
    }

    if (menuItem.path) {
      _emits("navigate");
      if (menuItem.path.startsWith("http"))
        window.open(menuItem.path, "_blank");
      else router.push(menuItem.path);
    }
  }
}

function getMenu(id: string, array?: MenuItem[]): MenuItem | undefined {
  if (!array) {
    return undefined;
  }
  let res = undefined;

  res = array.find((t) => t.id === id);

  if (res) {
    return res;
  }

  for (const t of array.filter((t) => t.items && t.items?.length > 0)) {
    res = getMenu(id, t.items);
    if (res) {
      break;
    }
  }
  return res;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TreeViewComponent), {
      id: "mainTree",
      "css-class": "main-treeview",
      fields: fields,
      "expand-on": "Click",
      onNodeClicked: onClicked,
      onNodeSelected: onSelected
    })
  ]))
}
}

})